<template>
    <div class="col-xs-12">
        <div class="bordered-title">
            <span class="fa fa-question"></span>
            <h3>الدعم الفني</h3>
        </div>
        <div class="body f-f-jf-flat">
            <transition-group name="fade">
                <form class="" id="TicketForm" v-show="!sent && !throttled" :key="1">
                    <select class="form-control" v-model="ticket.TicketTypeId" required="">
                        <option :value="null" disabled="disabled">اختر نوع الدعم...</option>
                        <option v-for="ticketType in ticketTypes" :value="ticketType.Id" :key="ticketType.Id">
                            {{ ticketType.Title }}
                        </option>
                    </select>

                    <select class="form-control" v-model="ticket.ProductId" required="">
                        <option :value="null" disabled="disabled">اختر نوع المنتج...</option>
                        <option v-for="product in products" :value="product.Id" :key="product.Id">{{ product.Title }}
                        </option>
                    </select>

                    <input class="form-control" placeholder="الموضوع..." required="" v-model="ticket.Title">
                    <input class="form-control" placeholder="البريد الالكتروني..." required="" type="email"
                           v-model="ticket.Email">
                    <input class="form-control onlyNumbers" placeholder="رقم الهاتف..." required=""
                           v-model="ticket.Phone1">
                    <textarea class="form-control" placeholder="اكتب ما الذي تريد الاستفسار عنه ....."
                              style="height:250px"
                              v-model="ticket.Description"
                              required=""></textarea>

                    <button class="btn btn-custom  col-xs-12" @click="submitTicket()"><span class="fa fa-send"></span>
                        <span>أرسل</span></button>

                    <div class="clearfix"></div>
                </form>

                <p class="thanks" v-show="sent" :key="2">
                    تم استلام طلبك بنجاح! إنّ رقم الطلب هو <span class="co-orange">{{ ticketSN }}</span>. سيتم التواصل معك في أقرب وقت ممكن.
                </p>

                <p class="thanks" v-show="throttled" :key="3">
                    لقد قمت بارسال طلب منذ قليل بالفعل!
                </p>
            </transition-group>
        </div>
    </div>
</template>
<script>
    export default {
        data: () => ({
            ticketTypes: [],
            products: [],
            sent: false,
            throttled: false,
            ticketSN: "",
            ticket: {
                Title: null,
                Email: null,
                Phone1: null,
                Description: null,
                ProductId: null,
                TicketTypeId: null,
            }
        }),

        beforeMount() {
            axios.get(apiHost + "/ticket-types")
                .then((response) => {
                    this.ticketTypes = response.data;
                })
                .catch((error) => console.log(error));

            axios.get(apiHost + "/products?all=true")
                .then((response) => {
                    this.products = response.data;
                })
                .catch((error) => console.log(error));
        },

        methods: {
            validateTicket() {
                if (this.isNullOrEmpty(this.ticket.ProductId)) return false;
                if (this.isNullOrEmpty(this.ticket.TicketTypeId)) return false;
                if (this.isNullOrEmpty(this.ticket.Title)) return false;
                if (this.isNullOrEmpty(this.ticket.Description)) return false;

                return true;
            },

            submitTicket() {
                if (!this.validateTicket()) return;
                NProgress.start();
                axios.post(apiHost + "/products/" + this.ticket.ProductId + "/place-ticket", this.ticket)
                    .then((response) => {
                        NProgress.done();
                        this.ticketSN = response.data.Data.TicketSN;
                        this.sent = true;
                    })
                    .catch((error) => {
                        if (error.response.status == 409)
                            this.throttled = true;
                        NProgress.done();
                    });
            }
        }
    }
</script>

<style lang="scss">
    @import "src/assets/sass/shared.scss";

    .bordered-title {
        @include text-align($dir);
        border-bottom: 1px solid #ccc;
        h3 {
            display: inline-block;
        }
    }

    .form-control {
        margin-bottom: 5px;
        height: 40px;

        input, select {
            border: 1px solid #ccc;
        }
    }

    .thanks {
        font-size: 19px;
    }

    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// src/components/technical support/ticket.vue